import { render, staticRenderFns } from "./config-list.vue?vue&type=template&id=19b61b87"
import script from "./config-list.vue?vue&type=script&lang=js"
export * from "./config-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports